export default __webpack_public_path__ + "media/images/services-01-770x485-0816c843b658c1c8540a45b140c3d473.jpg";